import { render } from "./ChatArea.vue?vue&type=template&id=5ecf4d6f&scoped=true&ts=true"
import script from "./ChatArea.vue?vue&type=script&lang=ts"
export * from "./ChatArea.vue?vue&type=script&lang=ts"

import "./ChatArea.vue?vue&type=style&index=0&id=5ecf4d6f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecf4d6f"]])

export default __exports__